import React from "react"
import LegalDocumentPage from "@/features/legal/components/LegalDocumentPage"
import { TERMS_OF_USE } from "@/features/legal/content/legalContent"

const TermsOfUsePage: React.FC = () => <LegalDocumentPage legalDocument={TERMS_OF_USE} />

export default TermsOfUsePage
